import React, {useEffect, useState} from 'react';
import {Nav} from "../../Components";
import "./Referral.scss";
import "../Coupon/Coupon.scss"
import {Alert, Spin,Button} from "antd";
import 'antd/dist/antd.css';
import Rodal from "rodal";
import {CheckinData} from "../Scan/ScanServices";
import toaster from "toasted-notes";
import {CouponData} from "../Menu/MenuServices";
import {DeleteOutlined,ContactsOutlined,CloseOutlined} from '@ant-design/icons';
import {getReferralApi, referralApi} from "./ReferralServices";
import {useLocation, useParams} from "react-router-dom";
import {find} from "dom7";
import { v4 as uuidv4 } from 'uuid';
import {useResp} from "../../hooks";
import {ReferralDesktop} from "./ReferralDesktop";
import DrShopHeader from "../../Components/DrShopHeader/DrShopHeader";

function Success(props) {
    return(
        <div className="success_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}






function PhoneCard({item,deleteItem,setVal,setValidation}){
    const [validationMessage,set_validationMessage] = useState("شماره موبایل معتبر وارد نمایید");
    const Regex ={mobile : /^(\+98|0)?9\d{9}$/,}

    const validation = ()=>{
        let res =  Regex.mobile.test(item.val)
        if(res)
            setValidation(true,item.uid)
        else
            setValidation(false,item.uid)
    }

    useEffect(()=>{
        console.log("rrrrrrrr")
        validation()
    },[item.val])

    return(
        <div className="input-mobile-referral-wrapper">
            <div className="input-mobile-referral">
                {item.removable?<span className="referral-delete-badge" onClick={()=>{
                    deleteItem(item.uid)
                }}>
                <CloseOutlined />
            </span>:null}
                <input
                    style={{textAlign:"center"}}
                    value={item.val}
                    onChange={(e)=>{
                        setVal(e.target.value,item.uid)
                    }}
                    type="text" name="" id="" placeholder="شماره دوستتان"/>
                <span className="referral-badg">به شماره</span>
            </div>
            {!item.validation?<div className="phonecard-message">
                <span>{item.message?item.message:validationMessage}</span>
            </div>:null}
            </div>
    )
}





function Referral (){

    const location = useLocation();
    const { id } = useParams();
    const resp = useResp();

    useEffect(()=>{
        console.log("id : ", id)
        // console.log("id : ", location.state.item)
        if(location.state && location.state.item)
            set_merchant(location.state.item)


        set_phones([...phones, {phone:"",uid:uuidv4(),val:"",validation:false,removable:false}])

    },[])


    const [phones,set_phones] = useState([])

    const deletePhone = (uid)=>{
        set_phones(phones.filter(p=>p.uid!==uid))
    }

    const setPhoneVal = (val,uid)=>{
        set_phones(
            phones.map(item =>
                item.uid === uid
                    ? {...item, val : val}
                    : item
            ))
    }

    //---------------------------------------------------------------

    // function PhoneCardMain(){
    //     const [validationMessage,set_validationMessage] = useState("شماره موبایل معتبر وارد نمایید");
    //     const Regex ={mobile : /^(\+98|0)?9\d{9}$/,}
    //
    //     const [validate,set_validate] = useState(false)
    //
    //     const validation = ()=>{
    //         let res =  Regex.mobile.test(referredMobile)
    //         if(res)
    //             set_validate(true)
    //         else
    //             set_validate(false)
    //     }
    //
    //     useEffect(()=>{
    //         console.log("rrrrrrrr")
    //         validation()
    //     },[referredMobile])
    //
    //     return(
    //         <div className="input-mobile-referral-wrapper">
    //             <div className="input-mobile-referral">
    //                 <input
    //                     style={{textAlign:"center"}}
    //                     value={referredMobile}
    //                     onChange={(e)=>{
    //                         set_referredMobile(e.target.value)
    //                     }}
    //                     type="text" name="" id="" placeholder="شماره دوستتان"/>
    //                 <span className="referral-badg">به شماره</span>
    //             </div>
    //             {!validate?<div className="phonecard-message">
    //                 <span>{validationMessage}</span>
    //             </div>:null}
    //         </div>
    //     )
    // }


    //----------------------------------------------------------

    const setValidation = async (val,uid)=>{
        set_phones(
            phones.map(item =>
                item.uid === uid
                    ? {...item, validation : val}
                    : item
            ))
    }




    const [merchant,set_merchant] = useState(null)
    const [couponLoading,set_couponLoading] = useState(false)
    const [couponCode,set_couponCode] = useState("")
    const [couponMessage,set_couponMessage] = useState("در این قسمت شما میتوانید دوستان خود را به اپلیکیشن داروخانه دعوت کنید و بابت دعوت هر نفر 10 امتیاز وفاداری کسب نمایید ")

    // const [couponCode,set_couponCode] = useState("")

    const [userName,set_userName] = useState("")
    //get local user



    useEffect(()=>{
        const localUser = localStorage.getItem("user");
        if(localUser){
            let parsedUser = JSON.parse(localUser)
            if(parsedUser.first_name){
                set_userName(parsedUser.first_name+" "+parsedUser.last_name)
            }

        }
    },[])



    const [referredMobile,set_referredMobile] = useState("")
    const [referredName,set_referredName] = useState("")


    const addedPhone = async ()=>{
        set_phones([...phones, {phone:"",uid:uuidv4(),val:"",validation:false,removable:true}])
    }


    const sendReferrer = async ()=>{

    //validation

        if(!userName)
            return toaster.notify(({ onClose }) => (<Error   message={"نام خودتان  برای دعوت لازم است"}/>),{duration: 2000});

        //check valid
        if(phones.find(p=>!p.validation))
            return toaster.notify(({ onClose }) => (<Error   message={"لطفا شماره موبایل معتبر وارد نمایید"}/>),{duration: 2000});

    //create phones obj
        let phonesi =[]
        phones.forEach(p=>{
            phonesi.push({phone: p.val})
        })



        try{
            const res = await referralApi({
                phones:phonesi,
                type:1,
                campaign:null
            },merchant.uid)
            set_referredName("")
            set_referredMobile("")

            //reValidate phones list

                //check send/receive count
                    let resList = res.data;
                    let resListCount = res.data.length;
                    let phonesCount = phones.length;
                    if(resListCount === phonesCount){
                        toaster.notify(({ onClose }) => (<Success message={"دعوت نامه با موفقیت ارسال شد"}/>), {duration: 2000});
                    }

                    if(resListCount===0){
                        toaster.notify(({ onClose }) => (<Error   message={"ارسال دعوت نامه مقدور نمی باشد"}/>),{duration: 2000});
                    }

                    if(resListCount !== phonesCount){
                        toaster.notify(({ onClose }) => (<Error   message={"ارسال دعوت نامه به تعدادی از شماره ها مقدور نمی باشد"}/>),{duration: 2000});
                    }

                    //remove success from phones

            let successPhones = resList.map(r=>r.invited_user.phone)
            // console.log("phones",phones)
            // console.log("successPhones",successPhones)
            set_phones(phones.filter(p=> !successPhones.includes(p.val)).map(p=>{
                return {...p, validation : false,message:"ارسال دعوتنامه به این شماره مقدور نمیباشد"}
            }))
            // set_phones(
            //     phones.map(p=>{
            //         return {...p, validation : false}
            //     }))




                    // validate false failed & message exist in system
        }catch(e){
            console.log(e)
            toaster.notify(({ onClose }) => (<Error   message={"ارسال دعوت نامه مقدور نمی باشد"}/>),{duration: 2000});
        }
    }



    //--------------------------------------------------------------------
    const [allowContacts,set_allowContacts] = useState(false)
    const [access,set_access] = useState([])
    const [con,set_con] = useState([])
    const opts = {multiple: true};

    useEffect(()=>{
        checkContacts()
        checkProperties()
    },[])

    function checkContacts(){
        if('contacts' in navigator){
            set_allowContacts(true)
        }else{
            set_allowContacts(false)
        }
    }

    const Regex ={mobile : /^(\+98|0)?9\d{9}$/,}


    async function getContacts() {
        try {
            const contacts = await navigator.contacts.select(access, opts);
            console.log(contacts)
            set_referredMobile(contacts[0].tel)
            set_referredName(contacts[0].name)
            //push selected contact to phones list

            let contactList = []
            contacts.forEach(contact=>{
                let tel= contact.tel;
                if(tel){
                    tel = tel[0].replace(/\s/g,'');
                    tel = tel.replace('+98','0');
                    if(Regex.mobile.test(tel))
                        contactList.push({phone:"",uid:uuidv4(),val:tel,validation:true,removable:true})
                    else
                        contactList.push({phone:"",uid:uuidv4(),val:tel,validation:false,removable:true})
                }

            })

            //set_phones([...phones,...contactList])
            set_phones(contactList)
            set_con(contacts);

        } catch (ex) {
            console.log(ex)
            // Handle any errors here.
        }
    }

    async function checkProperties() {
        let accessList = []
        if(!navigator.contacts)
            return false

        const supportedProperties = await navigator.contacts.getProperties();
        if (supportedProperties.includes('name')) {
            // run code for name support
            accessList.push("name")
        }
        if (supportedProperties.includes('email')) {
            // run code for email support
            accessList.push("email")
        }
        if (supportedProperties.includes('tel')) {
            // run code for telephone number support
            accessList.push("tel")
        }
        if (supportedProperties.includes('address')) {
            // run code for address support
            accessList.push("address")
        }
        if (supportedProperties.includes('icon')) {
            // run code for avatar support
            accessList.push("icon")
        }

        set_access(accessList)
    }

    //-------------------



    return(
        <div>
            {resp?<div>

                <ReferralDesktop/>
                </div>:
                <div className="referral-container">
                    <DrShopHeader home={true}/>
                    <div className="landing-container">
                        <div className="a-pluse-subject">
                            {/*{merchant?<img src={merchant.thumbnail} alt=""/>:null}*/}
                            {/*{merchant bv78?<span> {merchant.name}</span>:null}*/}
                        </div>
                        <div className="menu-container landing-back" style={{
                            backgroundImage: `url(${"https://disruptiveadvertising.com/static/42674911b6ea9dffb0aa1efc9f3a6dc7/e57f1/referral-marketing-blog.jpg"})`}}>


                            {/* ------------- Chart Section ----------------- */}



                            <div className="coupon_p2_wr">

                                <div className="coupon_p2_sec" style={{paddingBottom:100}}>
                                    {allowContacts?
                                        <div onClick={()=>{getContacts()}} className="contact-badg">
                                            <ContactsOutlined />
                                        </div>
                                        :null}
                                    {merchant? <div className="online-store-sec land-btn coupon_p2_land"  >
                                        <span className="merchant-name">{location.state.item.name}</span>

                                        <div className="input-mobile-referral-wrapper">
                                            <div className="input-mobile-referral">
                                                <input
                                                    style={{textAlign:"center"}}
                                                    value={userName}
                                                    onChange={(e)=>{
                                                        set_userName(e.target.value)
                                                    }}
                                                    type="text" name="" id="" placeholder="نام خودتان"/>
                                                <span className="referral-badg">از طرف </span>
                                            </div>
                                        </div>


                                        {/*<div className="input-mobile-referral" style={{marginTop:15}}>*/}
                                        {/*    <input*/}
                                        {/*        style={{textAlign:"center"}}*/}
                                        {/*        value={referredName}*/}
                                        {/*        onChange={(e)=>{*/}
                                        {/*            set_referredName(e.target.value)*/}
                                        {/*        }}*/}
                                        {/*        type="text" name="" id="" placeholder="نام دوستتان "/>*/}
                                        {/*    <span className="referral-badg">به  </span>*/}
                                        {/*</div>*/}

                                        {/*<br/>*/}

                                        {/*<div className="input-mobile-referral-wrapper">*/}
                                        {/*    <div className="input-mobile-referral">*/}
                                        {/*        <input*/}
                                        {/*            style={{textAlign:"center"}}*/}
                                        {/*            value={referredMobile}*/}
                                        {/*            onChange={(e)=>{*/}
                                        {/*                set_referredMobile(e.target.value)*/}
                                        {/*            }}*/}
                                        {/*            type="text" name="" id="" placeholder="شماره دوستتان"/>*/}
                                        {/*        <span className="referral-badg"> به شماره </span>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}

                                        {/*<PhoneCardMain/>*/}



                                        {phones.map(p=>{
                                            return(
                                                <PhoneCard item={p} deleteItem={deletePhone} setVal={setPhoneVal} setValidation={setValidation}/>
                                            )
                                        })}
                                        <br/>

                                        <div style={{backgroundColor: "orange",margin: "10px 0"}} onClick={()=>{
                                            addedPhone()
                                        }} className="online-store-btn">
                                            <span>افزودن شماه ره ای دیگر</span>
                                        </div>

                                        <div onClick={()=>{
                                            sendReferrer()
                                        }} className="online-store-btn">
                                            <span>ارسال به معرفی شونده</span>
                                        </div>



                                    </div>:null}
                                </div>
                            </div>



                            {/*{merchant?<div className="merchant-desc" style={{paddingTop:230}}>*/}
                            {/*    <br/>*/}
                            {/*    <div className="referral-subject">*/}
                            {/*        <span>راهنمای استفاده</span>*/}
                            {/*        <StarFilled />*/}
                            {/*    </div>*/}
                            {/*    <div style={{padding:"5px 0"}}></div>*/}
                            {/*    <p className="coupon_message">{couponMessage}</p>*/}
                            {/*    <br/>*/}
                            {/*    <Alert*/}
                            {/*        message="توجه"*/}
                            {/*        description="برای استفاده از این امکان باید در قسمت پروفایل نام و نام خانوادگی را تکمیل کرده باشید "*/}
                            {/*        type="warning"*/}
                            {/*        showIcon*/}
                            {/*        closable*/}
                            {/*    />*/}
                            {/*</div>:<div className="merchant-desc" style={{paddingTop:20}}>*/}
                            {/*    <br/>*/}
                            {/*    <Alert*/}
                            {/*        description="هیچ فروشگاهی انتخاب نشده است . لطفا از صفحه فروشگاه از لیست فروشگاهها اقدام به ارسال دعوت نامه برای دوستان نمایید"*/}
                            {/*        type="warning"*/}
                            {/*        showIcon*/}
                            {/*        closable*/}
                            {/*    />*/}
                            {/*</div>}*/}


                        </div>
                    </div>
                    <Nav/>
                </div>}

        </div>

    )
}

export {Referral};
